import { AccessTimeTwoTone } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { SystemRecordTypeEnum } from './types';

interface Props {
  dueOn?: string,
  createdAt?: string,
  systemRecordType: SystemRecordTypeEnum,
}

const RecordKeyDates: React.FC<Props> = ({ systemRecordType, createdAt, dueOn }) => {
  const timeZone = moment.tz.guess();
  let createdDate = `Reported on: ${moment(createdAt).tz(timeZone).format('MMMM Do, YYYY')}`;
  const dueDate = dueOn ? moment(dueOn).format('MMMM Do YYYY') : '';
  const today = moment().tz(timeZone);
  const yesterday = moment().tz(timeZone).subtract(1, 'days');
  const createdToday = moment(createdAt).tz(timeZone).isSame(today, 'day');
  const createdYesterday = moment(createdAt).tz(timeZone).isSame(yesterday, 'day');
  const isSystemRecordIssues = systemRecordType === SystemRecordTypeEnum.Issues;
  if (createdToday) {
    createdDate = `Reported today: ${moment(createdAt).tz(timeZone).format('hh:mm A')}`;
  }
  if (createdYesterday) {
    createdDate = 'Reported yesterday.';
  }
  const overDue = dueDate ? moment(dueOn || '').endOf('day').isBefore(today, 'hour') : false;
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      color="gray"
    >
      {isSystemRecordIssues && (
        <Typography variant="body2">
          {`${createdDate}`}
        </Typography>
      )}
      {!isSystemRecordIssues && (
        <>
          <AccessTimeTwoTone
            sx={{ marginRight: '5px' }}
            style={{
              color: overDue ? '#FF3B30' : 'gray',
            }}
          />
          <Typography
            variant="body2"
            style={{
              color: overDue ? '#FF3B30' : 'gray',
            }}
          >
            {overDue ? 'Overdue' : dueDate}
            {!dueDate && 'No due date'}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default RecordKeyDates;
